
import { GoogleGenAI } from "@google/genai";

// Initialize cautiously
const getApiKey = () => {
  // Check both standard process.env and a direct check
  return process.env.API_KEY || '';
};

// We don't initialize immediately to avoid crashes if API_KEY is missing at top-level execution
let aiInstance: GoogleGenAI | null = null;

const getAi = () => {
  if (!aiInstance) {
    const key = getApiKey();
    if (key) {
      aiInstance = new GoogleGenAI({ apiKey: key });
    }
  }
  return aiInstance;
};

export const generateLoveMessage = async (
  sender: string,
  receiver: string,
  amount: number,
  category: string
): Promise<string> => {
  const ai = getAi();
  if (!ai) {
    console.warn("API_KEY not configured. Falling back to default message.");
    return "Um Pix especial cheio de carinho para você! ✨";
  }

  try {
    const response = await ai.models.generateContent({
      model: 'gemini-3-flash-preview',
      contents: `Gere uma mensagem curta e criativa em Português para acompanhar um envio de Pix.
      Remetente: ${sender}
      Destinatário: ${receiver}
      Valor: R$ ${amount.toFixed(2)}
      Estilo: ${category}
      A mensagem deve ser amigável e calorosa. Máximo 140 caracteres.`,
      config: {
        temperature: 0.8,
        topP: 0.95,
      },
    });

    return response.text?.trim() || "Enviando um pouco de amor via Pix! ❤️";
  } catch (error) {
    console.error("Gemini Error:", error);
    return "Um Pix especial para você! ✨";
  }
};
